export default __webpack_public_path__ + "static/media/banner.21659fe9.svg";